import React from 'react';
import { Gradient } from '../Gradient';

const Lock = ({ type, className = '', color = '#737373' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="5" y="11" width="14" height="10" rx="2" 
        stroke={type === 'plain' ? color : 'url(#globalGradient)'} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"/>
      <path d="M7 11V7C7 4.79086 8.79086 3 11 3H13C15.2091 3 17 4.79086 17 7V11" 
        stroke={type === 'plain' ? color : 'url(#globalGradient)'} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"/>
      <circle cx="12" cy="16" r="1.5" 
        fill={type === 'plain' ? color : 'url(#globalGradient)'}/>
      <Gradient className={className} />
    </svg>
  );
};

export default Lock;
